module.exports = __webpack_public_path__ + "static/media/bill-orange.73a2ecbd.svg";